/** Navigation / editing keys we never block */
const NAV_KEYS = new Set([
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End'
]);

export function filterDecimalKeyDown(e) {
  if (NAV_KEYS.has(e.key)) return;
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (e.key.length !== 1) return;
  if (/[a-zA-Z]/.test(e.key)) {
    e.preventDefault();
    return;
  }
  if (e.key === '+' || e.key === '=') {
    e.preventDefault();
  }
}

export function filterIntegerKeyDown(e) {
  if (NAV_KEYS.has(e.key)) return;
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (e.key.length !== 1) return;
  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
  }
}

/**
 * Strip letters/spaces; keep digits and at most one of . or , as decimal separator; optional leading minus.
 */
export function sanitizeDecimalString(raw) {
  if (raw == null || raw === '') return '';
  let s = String(raw).replace(/[a-zA-Z]/g, '').replace(/\s/g, '');
  let neg = false;
  if (s.startsWith('-')) {
    neg = true;
    s = s.slice(1);
  }
  let sep = false;
  let out = '';
  for (const c of s) {
    if (c >= '0' && c <= '9') out += c;
    else if ((c === '.' || c === ',') && !sep) {
      out += c;
      sep = true;
    }
  }
  return neg ? `-${out}` : out;
}

/** Digits only (e.g. SMTP port, counts). */
export function sanitizeIntegerString(raw) {
  return String(raw ?? '').replace(/\D/g, '');
}
